import {Model} from 'backbone';
import $ from 'jquery';
import eventBus  from 'EventBus';
import BaseDashboardLeftPanelView from 'dashboard/BaseDashboardLeftPanelView';
import RestService from 'RestService';
import NotificationService from 'NotificationService';
import ConnectionDashboardController from 'ConnectionDashboardController';
import xjService from 'xml/XJService';

import FormLoadService from 'FormLoadService';

import ConnectionDetailsView from 'dashboard/connections/connection-type/ConnectionDetailsView';

import ConnectionDetailsModel   from 'ConnectionDetailsModel';
import ConnectionService    from 'dashboard/connections/ConnectionService';
import ActionService        from 'dashboard/connections/action-type/ActionService';

import constants    from 'Constants';
import listService  from 'ListService.js';
import ImportModal from 'common-views/ImportModalView.js';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import utils  from 'util/Util.js';
import userService from 'UserService.js';
import AlertDialogView    from 'common-views/AlertDialogView.js';
import textConstants    from 'TextConstants';

import ActionDetailsModel   from 'ActionDetailsModel';
import ActionDetailsView from 'dashboard/connections/action-type/ActionDetailsView';

const ICON_FOLDER = constants.DB_ICON_FOLDER;
const ICON_EMPTY = constants.DB_ICON_EMPTY;
const ICON_CONNECTION=constants.DB_ICON_CONNECTION;

class ConnectionsLeftPanelView extends BaseDashboardLeftPanelView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.selectedConnection = '';

        this.sections = {
            DATABASES: 'Databases',
            DIRECTORY_SERVICES: 'DirectoryServices',
            WEB_SERVICES:'WebServices',
            FORMS:'Apps',
            GOOGLE_SPREADSHEETS:'GoogleSpreadSheets',
            TEXT_FILES:'TextFiles',
            VECTOR_DATABASES:'VectorDatabases'
        };
        
        this.typeMap = {
            1: 'Database Connection',
            2: 'Directory Service Connection',
            3: 'SOAP Web Service Connection',
            4: 'Apps Connection',
            9: 'Google Sheets Connection',
            7: 'Text File Connection',
            11: 'REST Web Service Connection',
            12: 'Vector Database Connection'
        };
        // Most Events Should be at Base
        //this.events = {};

        // structure to load List
        const sections = {
            sections: [
                {
                    sectionName: 'Databases',
                    sectionType: 'sectionDatabases',
                    groupType: 'section',
                    id: constants.DATABASES_GROUP_TYPE,
                    nodeType: 'databases',
                    groups: [],
                    nodes:[]

                },
                {
                    sectionName: 'Directory Services',
                    sectionType: 'sectionDirectoryServices',
                    groupType: 'section',
                    id: constants.DIRECTORY_GROUP_TYPE,
                    nodeType: 'directory',
                    groups: [],
                    nodes: []
                },
                {
                    sectionName: 'SOAP Web Services',
                    sectionType: 'sectionWebServices',
                    groupType: 'section',
                    id: constants.WEB_GROUP_TYPE,
                    nodeType: 'web',
                    groups: [],
                    nodes: []
                },
                {
                    sectionName: 'REST Web Services',
                    sectionType: 'sectionRESTWebServices',
                    groupType: 'section',
                    id: constants.REST_GROUP_TYPE,
                    nodeType: 'rest',
                    groups: [],
                    nodes: []
                },
                {
                    sectionName: 'Apps',
                    sectionType: 'sectionForms',
                    groupType: 'section',
                    id: constants.FORMS_GROUP_TYPE,
                    nodeType: 'forms',
                    groups: [],
                    nodes: []
                },
                {
                    sectionName: 'Google Sheets',
                    sectionType: 'sectionGoogleSpreadsheets',
                    groupType: 'section',
                    id: constants.GOOGLE_GROUP_TYPE,
                    nodeType: 'google',
                    groups: [],
                    nodes: []
                },
                {
                    sectionName: 'Text File',
                    sectionType: 'sectionTextFile',
                    groupType: 'section',
                    id: constants.TEXT_GROUP_TYPE,
                    nodeType: 'text',
                    groups: [],
                    nodes: []
                },
                {
                    sectionName: 'Vector Databases',
                    sectionType: 'sectionVectorDatabases',
                    groupType: 'section',
                    id: constants.VECTORDB_GROUP_TYPE,
                    nodeType: 'vectordb',
                    groups: [],
                    nodes: []
                }
            ]
        };

        //this.listenTo( eventBus, 'shareReport', this.renderReportsDashboard );
        //this.listenTo( eventBus, 'deletingReport', this._onDeletingReport );
        //this.listenTo(eventBus, constants.SWITCH_DETAIL_REPORT, this._onDetailReportSwitch);
        this.listenTo(eventBus, constants.EV_UPDATE_CONNECTION_DETAILS, this.renderUpdatedConnectionDetails);
        this.listenTo(eventBus, constants.EV_UPDATE_ACTION_DETAILS, this.renderUpdatedActionDetails);
        this.listenTo(eventBus, constants.EV_DELETE_CONNECTION, this.onConnectionDeleted);
        this.listenTo(eventBus, constants.EV_DELETE_ACTION, this.onActionDeleted);
        this.listenTo(eventBus, constants.EV_ADD_ACTION, this.onActionAdded);
        this.listenTo(eventBus, 'relatedConnection', this.renderConnectionDetails);
        this.listenTo(eventBus, constants.EV_REFRESH_CONNECTION_NODES, this.refreshConnectionSection);
        this.listenTo(eventBus, constants.EV_REFRESH_CONNECTION_ACTIONS, this.refreshConnectionActions);
        this.listenTo(eventBus, constants.EV_REFRESH_ACTION_DETAILS, this.renderActionDetails);
        this.listenTo(eventBus, constants.EV_REFRESH_CONNECTION_DETAILS, this.renderConnectionDetails);


        this.model.set('connectionSections', sections, {silent: true});

        this.model.set('currentActiveSection', 'connectionSections', {silent: true});

//        this.listenTo(this.model, 'change', this.render);
//
        this.connectionService = new ConnectionService({model:this.model});
        this.actionService = new ActionService({model:this.model});

        utils.setUndoRedoAccess();

        return this;
    }

    onConnectionDeleted(connectionType){
        console.log('Connection Deletion captured from Settings Left Panel');
        this.initializeTree();
        ConnectionDashboardController.expandUpdatedConnectionListAndDetailView(this,'',connectionType);
    }

    onActionDeleted(connectionId, actionType){
        console.log('Action Deletion captured from Settings Left Panel');
        this.initializeTree();
        ConnectionDashboardController.expandUpdatedActionListAndDetailView(this,'',connectionId,actionType);
    }

    initializeTree(sectionContainer){
        //$(constants.RESOURCES_SECTION_CONTAINER).collapse('show');
        if(sectionContainer){
            $(sectionContainer).collapse('show');
            this.activateSection(null, sectionContainer);
        }
    }

    createNewDatabase(ev){
       this.initializeTree(constants.CONNECTION_DATABASES_CONTAINER);
       ConnectionDashboardController.createNew(this,constants.DATABASES_GROUP_TYPE);
       this.activateSection(ev);
    }

    createNewDirectoryService(){
        this.initializeTree(constants.CONNECTION_DIRECTORY_CONTAINER);
        ConnectionDashboardController.createNew(this,constants.DIRECTORY_GROUP_TYPE);
    }

    createNewWebService(){
        this.initializeTree(constants.CONNECTION_WEB_CONTAINER);
        ConnectionDashboardController.createNew(this,constants.WEB_GROUP_TYPE);
    }

    createNewRestWebService(){
        this.initializeTree(constants.CONNECTION_REST_CONTAINER);
        ConnectionDashboardController.createNew(this,constants.REST_GROUP_TYPE);
    }

    createNewForm(){
        this.initializeTree(constants.CONNECTION_FORMS_CONTAINER);
        ConnectionDashboardController.createNew(this,constants.FORMS_GROUP_TYPE);
    }

    createNewGoogleSpreadsheet(){
        this.initializeTree(constants.CONNECTION_GOOGLE_CONTAINER);
        ConnectionDashboardController.createNew(this,constants.GOOGLE_GROUP_TYPE);
    }

    createNewTextFile(){
        this.initializeTree(constants.CONNECTION_TEXT_CONTAINER);
        ConnectionDashboardController.createNew(this,constants.TEXT_GROUP_TYPE);
    }

    createNewVectorDB(){
        this.initializeTree(constants.CONNECTION_VECTORDB_CONTAINER);
        ConnectionDashboardController.createNew(this,constants.VECTORDB_GROUP_TYPE);
    }

    onActionAdded(connectionId, connectionType){
        ConnectionDashboardController.createAction(this, connectionId,connectionType)
    }

    renderUpdatedConnectionDetails(data){
        console.log('Re-rendering connection details for:',data.id);
        this.initializeTree();
        ConnectionDashboardController.expandUpdatedConnectionListAndDetailView(this, data.id,data.type);
    }

    renderUpdatedActionDetails(actionId,connectionId,actionType){
        console.log('Re-rendering actions details for:',actionId);
        console.log('Re-rendering connection details for:',connectionId);
        console.log('Re-rendering connection details for:',actionType);
        this.initializeTree();
        ConnectionDashboardController.expandUpdatedActionListAndDetailView(this, actionId,connectionId,actionType);
    }

    cleanDetailView(){
        console.log('Cleaning Detail');
        // Cleaning Detail View here if no email Server Id was sent.
        // If no Details View is Called just show the updated tree.
        if (this.detailView) {
            this.detailView.$el.empty().off();
            /* off to unbind the events */
            this.detailView.stopListening();
        }
        //$('#wellEmailsGroup').collapse('show');
    }

    validateConnectionTypeEnabled(connectionType){
        let result = true;
        if (connectionType === 'google' && !utils.isTrue(userService.checkFeatures('GoogleSpreadsheet'))) {
            result = false;
            const confirmView = new AlertDialogView({
                    model: new Model({
                        text: textConstants.GOOGLE_CONNECTIONS_FEATURE_NOT_ENABLED_TEXT,
                        title: textConstants.GOOGLE_CONNECTIONS_FEATURE_NOT_ENABLED_TITLE,
                        height: 200
                    })
                });

                confirmView.render();
        }

        return result;
    }

    handleExpand(ev) {
        console.log('Event 1', ev.currentTarget);

        try {
            ev.preventDefault();
        } catch (e) {

        }

        let itemId = ev.currentTarget.attributes['data-itemid'].value;
        let groupType = ev.currentTarget.attributes['data-groupType'].value;
        let nodeType = ev.currentTarget.attributes['data-nodeType'].value;

        const detailViewToRender = itemId.indexOf("-") < 0 ? nodeType : 'action';

        this.nodeType = nodeType;
        // let detailViewToRender = ev.currentTarget.attributes['data-nodeType'].value.length > 1
        //     ? ev.currentTarget.attributes['data-nodeType'].value
        //     : 'action';

        // Returning if the node selected is a section, as we do not have to re render the nodes on static sections.
        console.log('GroupType', groupType);
        console.log('NodeType', nodeType);
        console.log('Detail To Render', detailViewToRender);

        if (this.validateConnectionTypeEnabled(nodeType)) {
            // nodeType should drive what type of action needs to happen (i.e. API Call and View rendered as a result)
            // don't process on the collapse
            if (new RegExp('collapsed').test(ev.currentTarget.className)) {
                console.log('Entering on collapsed Reports');
                const _none = () => { };

                const _group = () => {
                    let dataTarget = ev.currentTarget.attributes['data-target'].value;
                    $('[data-target="' + dataTarget + '"]').toggleClass('pf-carot-left pf-carot-down');
                };

                const _databases = () => {
                    console.log('Entering databases');
                    this.processConnectionSection(constants.DATABASES_GROUP_TYPE, itemId, ev);
                };

                const _directory = () => {
                    console.log('Entering directory');
                    this.processConnectionSection(constants.DIRECTORY_GROUP_TYPE, itemId, ev);
                };

                const _web = () => {
                    console.log('Entering web');
                    this.processConnectionSection(constants.WEB_GROUP_TYPE, itemId, ev);
                };

                const _rest = () => {
                    console.log('Entering rest');
                    this.processConnectionSection(constants.REST_GROUP_TYPE, itemId, ev);
                };

                const _forms = () => {
                    console.log('Entering forms');
                    this.processConnectionSection(constants.FORMS_GROUP_TYPE, itemId, ev);
                };

                const _text = () => {
                    console.log('Entering text');
                    this.processConnectionSection(constants.TEXT_GROUP_TYPE, itemId, ev);
                };

                const _google = () => {
                    console.log('Entering google');
                    this.processConnectionSection(constants.GOOGLE_GROUP_TYPE, itemId, ev);
                };

                const _vectordb = () => {
                    console.log('Entering vectordb');
                    this.processConnectionSection(constants.VECTORDB_GROUP_TYPE, itemId, ev);
                };

                const _action = () => {
                    console.log('Entering action');
                    let connectionId = itemId.split('-')[1];
                    this.processActionSection(nodeType, connectionId, ev);
                };

                const map = {
                    'attn': _none,
                    'group': _group,
                    'databases': _databases,
                    'directory': _directory,
                    'web': _web,
                    'rest': _rest,
                    'forms': _forms,
                    'google': _google,
                    'text': _text,
                    'vectordb': _vectordb,
                    'none': _none,
                    'action': _action
                };
                (map[detailViewToRender])();
            }
            else {
                this.handleSection(ev);
            }

            this.collapseWithoutPropagation(ev);
        }
    }

    processConnectionSection(sectionId,itemId,ev){
        ev.stopPropagation();
        ev.preventDefault();

        RestService.getConnections(constants.DEFAULT_GROUP_ID,sectionId,constants.CONNECTIONS_DEFAULT_PURPOSE).then((data) => {
            let dataTarget;
            const outerThis = this;
            if (ev.currentTarget.children && ev.currentTarget.children.length > 1 ) {
                    dataTarget = ev.currentTarget.children[1].attributes['data-target'].value;
            }
            else{
                dataTarget = ev.currentTarget.attributes['data-target'].value;
            }

            ConnectionDashboardController.renderConnectionItems(this,data,itemId,dataTarget);

            // PF-1723: Adding bootstrapmenu
            this.attachRightClickMenu();

            this.handleSection(ev);
        }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        })
    }

    processActionSection(nodeType,connectionId,ev){
        RestService.getActionsByConnectionId(connectionId,constants.SETTINGS_CONNECTIONS_FORM_ID,constants.SETTINGS_CONNECTIONS_PURPOSE).then((data) => {
            let actionContainer=$(`i[data-itemid*='${connectionId}']`).attr('data-target');
            ConnectionDashboardController.renderActionItems(this,data,nodeType,connectionId,actionContainer);

            ev.stopPropagation();

        }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            //ev.stopPropagation();
        })
    }

    renderConnectionsDashboard(ev, type) {
        this.killDetailView();
        let dataTarget = ev.currentTarget.attributes['data-nodetype'].value;
        $('[data-nodetype="'+ dataTarget + '"] a i').toggleClass('pf-carot-left pf-carot-down');
    }

    // Override Base for Specific Handling
    handleSection(ev) {
        utils.cleanSelectedNodeOnDashboard();
        super.handleSection(ev);
    }

    handleSelectedGroup(ev) {
        let itemSelected = $(ev.currentTarget).parent().find('.bg-success');
        if (itemSelected.length > 0){
            listService.connectionItemSelected = undefined;
        }
        let sectionType = ev.currentTarget.attributes['data-nodeType'].value;
        let id = ev.currentTarget.attributes['data-groupid'].value;

        if (sectionType === constants.REPORTS_PRIVATE_SECTION || sectionType === constants.REPORTS_SHARED_SECTION) {
            let groupTypeId = id;
//            var target = ev.currentTarget.

            // if classname of children[1] contains 'collapsed' then ignore , only load on expand.
            if (new RegExp('collapsed').test(ev.currentTarget.children[1].className)) {
                let dataTarget = ev.currentTarget.children[1].attributes['data-target'].value;

                // RestService.getReportsByGroupType(groupTypeId).then((data) => {
                //     let reports = data.RESULT.RESPONSE.Group;
                //     if (reports) {
                //
                //         var nodes = this.loadNodesFromResponse(reports, groupTypeId);
                //
                //         // Update Model So It Will Be There Later, duh.
                //         var group = this.replaceGroupItemsInModel('reportSections', 'Edit Reports', groupTypeId, nodes);
                //         this.addItemsToGroup(group, dataTarget);
                //     }
                //
                // }).catch((error) => {
                //     console.log(error);
                //
                //     var msg = error || 'Unknown Error';
                //     NotificationService.error(msg);
                // });
            }else{
                this.collapseWithoutPropagation(ev);
            }

        }

    }

    handleSelectedGroupItem(ev) {
        let spinner=$(".spinner").is(":visible");
        if(ev.type === 'click' && (!spinner)){
            try {
                ev.preventDefault();
            } catch (e) {
                console.log('error', e);
            }

            if (this.detailView) {
                let subtitle = '';
                if (this.detailView.model.get('connectionDetails')) {
                    subtitle = `Connection - ${this.detailView.model.get('connectionDetails').Name}`;
                }
                else if (this.detailView.model.get('actionDetails')) {
                    subtitle = `Connection - ${this.detailView.model.get('actionDetails').Name}`;
                }

                const applyChangesElement = $('input[name="applyChanges"]'),
                    confirmationText = 'Are you sure you want to leave this page?<br /><br />All changes made to the current page will be lost.';

                utils.showConfirmationDashboardChangesModal(applyChangesElement, this.openGroupDetailView, confirmationText, subtitle, ev,this);
            }
            else {
                this.openGroupDetailView(ev)
            }

            this.activateSection(ev);
        }
    }

    handleDblSelectedGroupItem(ev) {
        const target = $(ev.currentTarget);
        const nodeType = target.attr('data-nodetype');
        const innerText = target.text();

        if (ev.type === 'dblclick' && nodeType!=='' && innerText !== '') {
            try {
                ev.preventDefault();
            }
            catch (e) {
                console.log('error', e);
            }

            window.oriVal = innerText;
            target.text('');
            $(utils.inputRenameTree(innerText)).appendTo(target).focus().select();
        }
        return false;
    }

    handleFocusOut(ev){
        var $this = $(ev.currentTarget);
        var parent=$this.parent();
        let nodeType=parent.attr('data-nodetype');
        let groupType=parent.attr('data-grouptype');
        let connectionId=parent.attr('data-itemid').split('-')[1];
        let actionId=parent.attr('data-itemid').split('-')[0];

        let name=$this.val().trim() || window.oriVal;
        $this.parent().text(name);
        if($this.val().trim()!== window.oriVal.trim()){
            if($('#dashboard-left-panel .item-link').is(':disabled')===false) {
                $('#dashboard-left-panel .item-link').prop('disabled', true);
                if(actionId==='undefined'){
                    RestService.updateConnectionName(connectionId, name).then(data => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                        eventBus.trigger(constants.EV_UPDATE_CONNECTION_DETAILS,{
                            id: connectionId,
                            type:nodeType
                        });
                    },  err => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                    });
                }else{
                    RestService.updateActionName(actionId, connectionId, name).then(data => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                        eventBus.trigger(constants.EV_UPDATE_ACTION_DETAILS, actionId, connectionId, nodeType);
                    },  err => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                    });
                }
            }
        }

        $this.remove();
    }

    handleEnter(ev){
        var code = ev.keyCode || ev.which;
        if (code === 13) {
            ev.preventDefault();
            $(ev.currentTarget).blur();
        }
    }

    openGroupDetailView(ev){
        console.log('Connection group item reports clicked');
        const connections=ev.currentTarget.attributes['data-itemid'].value.split('-');
        const connId = connections[0];
        const connectionId = connections[1];
        const groupType = ev.currentTarget.attributes['data-groupType'].value;

        // Check in order to expand between an action or a connection parent node
        const nodeType = ev.currentTarget.attributes['data-nodeType'].value;

        if (nodeType.length === 1) {
            this.selectedConnection = connId + '-' + connectionId;
        }

        const viewToRender = connId === "undefined" ? 'connection' : 'action';

        const formName = $(ev.currentTarget).text();
        this.removeItemGroupSelection();
        this.addItemGroupSelection(ev.currentTarget);

        const _attn = () => {
            this.killDetailView();
        };

        const _connection = () => {
            this.renderConnectionDetails(connectionId, nodeType);
        };

        const _action = () => {
            if(!connectionId){
                return;
            }
            this.killDetailView();

          this.renderActionDetails(connId, connectionId, nodeType);

        };

        const map = {
            'attn': _attn, 'connection':_connection,'action': _action
        };

        const fn = map[viewToRender];
        if (fn) {
            (fn)();
        }
    }

    renderActionDetails(actionId,connectionId){
        utils.disableReloadLink();
        let self = this;

        RestService.getParametersByActionIdAndConnectionId(actionId,
            connectionId,
            constants.SETTINGS_CONNECTIONS_FORM_ID,
            constants.SETTINGS_CONNECTIONS_PURPOSE,true).then((actionResponse)=> {
            utils.enableReloadLink();
            console.log('Action Response', actionResponse);
            let unAllowedWebServiceType = '';
            if(actionResponse.details.Action._targetNamespace && actionResponse.details.Action._targetNamespace.includes(constants.SALESFORCE_NAMESPACE)){
                unAllowedWebServiceType = !userService.checkFeatures('SalesForce') ? 'salesforce' : '';
            }
            else if(actionResponse.details.Action._targetNamespace && actionResponse.details.Action._targetNamespace.includes(constants.SAP_NAMESPACE)){
                unAllowedWebServiceType = !userService.checkFeatures('SAP') ? 'sap' : '';
            }

            const actionDetailsModel= new ActionDetailsModel();

            let actionDetails = {
                Name: actionResponse.general.Name,
                Type: actionResponse.details.Action._type,
                ActionXML: actionResponse.details
            };

            listService.actionItemSelected = {
                actionId,
                connectionId,
                type: actionResponse.general.Type,
                name: actionResponse.general.Name
            };

            listService.connectionItemSelected = undefined;

            //Not all the Actions have permissions setted
            if (actionResponse.general.PermissionsXML){
                actionDetails.PermissionsXML = actionResponse.general.PermissionsXML.Permissions.User instanceof Array
                ? actionResponse.general.PermissionsXML.Permissions.User
                : [actionResponse.general.PermissionsXML.Permissions.User];
            } else {
                actionDetails.PermissionsXML = [];
            }

            if (actionDetails.Type.charAt(0) === constants.FORMS_GROUP_TYPE && actionResponse.general.SourceForm) {
                actionDetails.FormGUID=actionResponse.general.SourceForm['@GUID']
            }

            if (actionDetails.ActionXML.Action.Send === '') {
                actionDetails.ActionXML.Action.Send = {Parameter:[]};
            }

            if (actionDetails.ActionXML.Action.Receive === '') {
                actionDetails.ActionXML.Action.Receive = {'_distinctResults':'false',Parameter:[]};
            }

            if (!actionDetails.ActionXML.Action.Receive.Parameter) {
                actionDetails.ActionXML.Action.Receive = {Parameter:[]};
            }

            if (!actionDetails.ActionXML.Action.Tables || actionDetails.ActionXML.Action.Tables === '') {
                actionDetails.ActionXML.Action.Tables = {Table:{'_name':''}};
            }

            if (actionDetails.ActionXML.Action.Fields) {
                if (actionDetails.ActionXML.Action.Fields === '') {
                    actionDetails.ActionXML.Action.Fields.Field=[];
                }
                else{
                    actionDetails.ActionXML.Action.Fields.Field = actionDetails.ActionXML.Action.Fields.Field instanceof Array
                        ? actionDetails.ActionXML.Action.Fields.Field
                        : [actionDetails.ActionXML.Action.Fields.Field];
                }
            }

            actionDetails.ActionXML.Action.Send.Parameter = actionDetails.ActionXML.Action.Send.Parameter instanceof Array
                ? actionDetails.ActionXML.Action.Send.Parameter
                : [actionDetails.ActionXML.Action.Send.Parameter];

            actionDetails.ActionXML.Action.Receive.Parameter = actionDetails.ActionXML.Action.Receive.Parameter instanceof Array
                ? actionDetails.ActionXML.Action.Receive.Parameter
                : [actionDetails.ActionXML.Action.Receive.Parameter];

             const breadcrumbs = [
                {name: 'Connections', route: '#connections', id:"goToConnections"},
                {name: this.typeMap[self.nodeType], route: self.selectedConnection, id: "goToDatabases"},
                {name: 'Action', route: '', id: ''}
            ];

            actionDetailsModel.set('dashboardTitle', 'Action Details - ' + actionDetails.Name);
            // Breadcrumbs are a function of kind of action details: e.g. database, directory, form, ...
            actionDetailsModel.set('breadcrumbs', breadcrumbs);
            actionDetailsModel.set('actionId', actionId);
            actionDetailsModel.set('connectionId', connectionId);

            actionDetailsModel.set('actionDetails',  $.extend(true, {}, actionDetails));
            actionDetailsModel.set('currentActionDetails', $.extend(true, {}, actionDetails));
            actionDetailsModel.set('hasChanges', false);
            actionDetailsModel.set('unAllowedWebServiceType',unAllowedWebServiceType);
            actionDetailsModel.set('ownerId', actionResponse.general.OwnerId);

            let newDetailView = new ActionDetailsView({model: actionDetailsModel, el: constants.DASHBOARD_MAIN_PANEL,type:actionDetails.Type});
            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();
        }).catch((err => {
            utils.enableReloadLink();
            console.log('Error Retrieving Action Details Data ' , err);
            NotificationService.error('Error Retrieving Action Details Data ' + err.MESSAGE || err);
        }));
    }



    renderConnectionDetails(connectionId, type){
        if($('#dashboard-left-panel .item-link').is(':disabled')===false) {
            utils.disableReloadLink();
            this.killDetailView();
            this.nodeType = type;
            RestService.getConnectionDetails(connectionId).then((connectionDetails) => {
                utils.enableReloadLink();
                if (this.nodeType === undefined) {
                    this.nodeType = connectionDetails.Type;
                }

                const connectionDetailsModel = new ConnectionDetailsModel();
                // Final breadcrumb is function of type parameter
                let breadcrumbs = [
                    {name: 'Connections', route: '#connections', id: "goToConnections"},
                    {name: this.typeMap[connectionDetails.Type], route: this.nodeType, id: ''}
                ];
                if (connectionDetails['PermissionsXML']) {
                    connectionDetails['PermissionsXML'] = connectionDetails['PermissionsXML'].Permissions.User instanceof Array
                        ? connectionDetails['PermissionsXML'].Permissions.User
                        : [connectionDetails['PermissionsXML'].Permissions.User];
                }
                let connectionXML = FormLoadService._decompressForm(connectionDetails.ConnectionXML['#cdata-section']);


                const connectionObject = xjService.toJSON(connectionXML);

                connectionDetails.ConnectionXML = connectionObject;

                connectionDetailsModel.set('dashboardTitle', 'Connection Details - ' + connectionDetails.Name);
                connectionDetailsModel.set('breadcrumbs', breadcrumbs);
                connectionDetailsModel.set('connectionId', connectionId);
                connectionDetailsModel.set('connectionType', connectionDetails.Type);

                connectionDetailsModel.set('connectionDetails', $.extend(true, {}, connectionDetails));
                connectionDetailsModel.set('currentConnectionDetails', $.extend(true, {}, connectionDetails));
                connectionDetailsModel.set('hasChanges', false);

                listService.connectionItemSelected = {
                    name: connectionDetails.Name,
                    connectionId: connectionId,
                    connectionType: type
                };

                listService.actionItemSelected = undefined;

                let newDetailView = new ConnectionDetailsView({
                    model: connectionDetailsModel,
                    el: constants.DASHBOARD_MAIN_PANEL,
                    type: type
                });
                listService.dashboardLayout.mainPanelView = newDetailView;
                this.detailView = newDetailView;

                this.detailView.render();
            }).catch((err => {
                utils.enableReloadLink();
                console.log('Error Retrieving Connection Details Data ' + err);
                NotificationService.error('Error Retrieving Connection Details Data' + err.MESSAGE || err);
            }));
        }
    }

    import(){
        let model = new Model({width: 475, height: 'auto'});
        var importModal = new ImportModal({ model: model, el:content });

        importModal.selectedImport = 'connection';
        importModal.render();
    }

    refreshConnectionSection(sectionId,dataTarget,groupType){
        utils.cleanChildNodes(dataTarget);
        utils.disableReloadLink();
        RestService.getConnections(constants.DEFAULT_GROUP_ID,sectionId,constants.CONNECTIONS_DEFAULT_PURPOSE).then((data) => {
            utils.enableReloadLink();
            ConnectionDashboardController.renderConnectionItems(this,data,sectionId,dataTarget);
        }).catch((error) => {
            console.log(error);
            utils.enableReloadLink();
            const msg = error || 'Unknown Error';
            NotificationService.error(msg);
        })
    }

    refreshConnectionActions(itemId,groupType,nodeType,dataTarget){
        if(listService.dashboardLayout.leftPanelView.detailView.model.get('hasChanges')){

            let simpleModal=new SimpleConfirmModalView({
                model:new Model({subtitle:`Connection - ${listService.dashboardLayout.leftPanelView.detailView.model.get("connectionDetails").Name}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    this.processConnectionActionAndDetailView(itemId,groupType,nodeType,dataTarget)
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            this.processConnectionActionAndDetailView(itemId,groupType,nodeType,dataTarget)
        }
    }

    processConnectionActionAndDetailView(itemId,groupType,nodeType,dataTarget){
        utils.cleanChildNodes(dataTarget);
        utils.disableReloadLink();
        const connectionId=itemId.split('-')[1];
        RestService.getActionsByConnectionId(connectionId,constants.SETTINGS_CONNECTIONS_FORM_ID,constants.SETTINGS_CONNECTIONS_PURPOSE).then((data) => {
            utils.enableReloadLink();
            let actionContainer=$(`i[data-itemid*='${connectionId}']`).attr('data-target');
            ConnectionDashboardController.renderActionItems(this,data,nodeType,connectionId,actionContainer);
            this.renderConnectionDetails(connectionId,nodeType);
        }).catch((error) => {
            console.log(error);
            utils.enableReloadLink();
            const msg = error || 'Unknown Error';
            NotificationService.error(msg);
        })
    }

    _deleteConnectionFromContextMenu(data) {
        if (String(data.nodetype).length === 1) {
            this.connectionService.deleteConnection();
        } else {
            this.actionService.deleteAction();
        }
    }

    render() {
        super.render();
        //Default view comes from the Dashboard View.
    }
}

export default ConnectionsLeftPanelView;
